<template>
    <div class="main-content">
        <table
            class="inv-table"
            aria-colcount="4"
            v-for="(service, serviceKey) in invoiceItems"
            :key="serviceKey"
        >
            <thead :class="`dark-bg-${variant}`">
                <tr>
                    <th>{{ serviceKey }}</th>
                    <th>$ {{ serviceSubtotal[serviceKey] }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(region, regionKey) in service" :key="regionKey">
                    <td colspan="2">
                        <table
                            class="inv-table"
                            aria-colcount="4"
                            :key="regionKey"
                        >
                            <thead :class="`dark-bg-${variant}`">
                                <tr>
                                    <th>{{ regionKey }}</th>
                                    <th>Price</th>
                                    <th>Quantity</th>
                                    <th>Sub Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(item, i) in region"
                                    :key="i"
                                    :class="darken(i) ? 'light-grey-bg' : ''"
                                >
                                    <td>
                                        {{
                                            item.Description == null
                                                ? item.line_item_line_item_description
                                                : item.Description
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            item.Price == null
                                                ? item.line_item_unblended_rate
                                                : item.Price
                                        }}
                                    </td>
                                    <td>
                                        {{ item.item_usage_amount }}
                                        {{ item.pricing_unit }}
                                    </td>
                                    <td>
                                        {{
                                            item.SubAmount == null
                                                ? item.item_unblended_cost
                                                : item.SubAmount
                                                  | formatCurrency(
                                                      currency.code
                                                  )
                                        }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
        <table
            class="inv-table"
            aria-colcount="4"
            v-if="Object.keys(invoiceItems).length > 0 && discount.total != 1"
        >
            <thead :class="`dark-bg-${variant}`">
                <tr>
                    <th>AWS Partner Discount</th>
                    <th>-$ {{ getDiscount }}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td colspan="2">
                        <table class="inv-table" aria-colcount="4">
                            <thead :class="`dark-bg-${variant}`">
                                <tr>
                                    <th>Discount Rate</th>
                                    <th>Price</th>
                                    <th>Quantity</th>
                                    <th>Sub Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        {{
                                            'AWS Partner Discount ' +
                                            (
                                                100.0 -
                                                parseFloat(discount.total) * 100
                                            ).toString() +
                                            '%'
                                        }}
                                    </td>
                                    <td>-{{ getDiscount }}</td>
                                    <td>1</td>
                                    <td>-${{ getDiscount }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import currencyFormatter from 'currency-formatter';

export default {
    name: 'app-items',
    props: ['currency', 'variant', 'discount'],
    data() {
        return {
            fields: ['Description', 'price', 'quantity', 'SubAmount'],
        };
    },
    computed: {
        ...mapGetters({
            invoiceItems: 'getInvoiceItems',
            subTotal: 'getSubTotal',
            total: 'getTotal',
            totalTaxes: 'getTotalTaxes',
            serviceSubtotal: 'getServiceSubtotal',
            getDiscount: 'getDiscount',
        }),
    },
    mounted() {
        this.$store.dispatch('setTotalAmount', parseFloat(this.total));
    },
    filters: {
        formatCurrency: (value, currency) => {
            if (!value) return currencyFormatter.format(0, { code: currency });
            return currencyFormatter.format(value, { code: currency });
        },
    },
    methods: {
        darken(i) {
            return i % 2;
        },
    },
};
</script>

<style lang="scss" scoped>
.main-content {
    width: 100%;
}

.inv-table {
    width: 100%;
    margin-bottom: 1rem;
    border-collapse: collapse;
    font-family: Arial, Helvetica, sans-serif;
}

.invoice-summary {
    display: flex;
    flex-direction: column;
    text-align: right;
    align-items: flex-end;

    & div {
        text-align: right;
        width: 25rem;
        display: flex;
        justify-content: space-between;

        &:last-of-type {
            margin-top: 2rem;
        }

        & span {
            display: inline-block;
            flex-basis: 50%;
        }
    }
}
</style>
